const SET_INITIALIZED = 'app/auth/base/set/initialized';
const LOG_OUT = 'app/auth/base/logout';

const SET_AUTHENTICATED = 'app/auth/base/set/isAuthenticated';

const SET_LOGIN_METHOD = 'app/auth/base/set/login/method';

const REMOVE_ERROR = 'app/auth/remove/error';

const SET_AUTHORIZATION_HEADER = 'app/auth/set/authorization_header';

const CLEAR_AUTHORIZATION_HEADER = 'app/auth/clear/authorization_header';

export {
    SET_INITIALIZED,
    LOG_OUT,
    SET_LOGIN_METHOD,
    SET_AUTHENTICATED,
    REMOVE_ERROR,
    SET_AUTHORIZATION_HEADER,
    CLEAR_AUTHORIZATION_HEADER,
};
